module.exports = __webpack_public_path__ + "static/media/51.3f524093.png";